module.exports = __webpack_public_path__ + "img/1_nyfw.24c83ca0.jpg";